import axios from 'axios'
import Qs from 'qs'

const apiClient = axios.create({
    // create single axios instance for entire app
    baseURL: '/deprecatedwebservice', // base URL to call
    timeout: 10000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

export default {
    getAppointement (appid) {
        return apiClient.get('get/appointment', {
            params: {
                id: appid
            }
        })
    },
    deleteAppointement (data) {
        return apiClient.post('delete/appointment', Qs.stringify(data))
    }
}
